/* tslint:disable */
/* eslint-disable */
/**
 * Yaway API
 * Yaway API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApiDamageAreaTemplate,
    ApiDamageAreaTemplateFromJSON,
    ApiDamageAreaTemplateToJSON,
} from '../models';

/**
 * 
 */
export class ClaimDamageTemplateApi extends runtime.BaseAPI {

    /**
     * returns all available vehicle templates
     */
    async getDamageLocationTemplatesRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<ApiDamageAreaTemplate>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/damage-location-template`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ApiDamageAreaTemplateFromJSON));
    }

    /**
     * returns all available vehicle templates
     */
    async getDamageLocationTemplates(initOverrides?: RequestInit): Promise<Array<ApiDamageAreaTemplate>> {
        const response = await this.getDamageLocationTemplatesRaw(initOverrides);
        return await response.value();
    }

}
